import useTranslate from "../../hooks/useTranslate";
import "./LanguageSwitch.scss";

const LanguageSwitch = () => {
  const { language, changeLanguage } = useTranslate();

  const isFarsi = language === "fa";

  const handleToggle = () => {
    const newLang = isFarsi ? "en" : "fa";
    changeLanguage(newLang);
    const path = window.location.pathname.replace(/^\/(?:fa|en)(?=\/|$)/, '') || '/';
    window.location.assign((newLang === 'fa' ? '/fa' + (path === '/' ? '' : path) : path) + window.location.search + window.location.hash);
  };

  return (
    <div className="language-switch" onClick={handleToggle}>
      <div className={`switch-track ${isFarsi ? "fa-active" : "en-active"}`}>
        <span className={`switch-label left ${!isFarsi ? "active" : ""}`}>
          EN
        </span>

        <span className={`switch-label right ${isFarsi ? "active" : ""}`}>
          فا
        </span>

        <div className="switch-thumb" />
      </div>
    </div>
  );
};

export default LanguageSwitch;
